<template>
  <div class="article-detail">
    <detail
      v-if="articleDetail.artical_image && articleDetail.artical_image.length > 0"
      :list="articleDetail.artical_image"
      :show-mark="processStatus === 0"
      class="detail-content"
    ></detail>
    <div
      v-if="processStatus !== 0"
      :class="[
        'article_status',
        { article_status_success: processStatus === 4 },
        { article_status_ing: processStatus === 2 }
      ]"
    >
      {{ articleDetail.extra_message }}
    </div>
    <div class="article_title">
      {{ articleDetail.title }}
    </div>
    <div class="article_message">
      <div class="article_message_user">
        <img class="headicon" :src="articleDetail.headicon" alt="" />
        <span class="name">{{ articleDetail.name }}</span>
        <span class="label">{{ articleDetail.province }}</span>
        <span class="label">{{ articleDetail.grade_name }}</span>
      </div>
      <score :rankNum="articleDetail.star" :thumb="articleDetail.thumb"></score>
    </div>
    <!--      教师评语模块-->
    <div class="comment" v-if="articleDetail.comment && articleDetail.comment !== ''">
      <div class="teacher_name">{{ articleDetail.teacher_name }}</div>
      <div class="comment_content">{{ articleDetail.comment }}</div>
    </div>
    <!--文章状态： 0 AI待审核 1 审核不通过 不可分享-->
    <!--文章状态： 2 初选中  -->
    <template v-if="processStatus === 2 && articleDetail.now_period_id == articleDetail.period_id">
      <div v-if="isSelf">
        <div class="share_btn" @click="toSharePoster(0)">邀请好友助力</div>
        <div class="share_tip">获得人气加分冲刺复选，赢精彩好礼</div>
      </div>
      <!--截止目前没有分享他人作文集赞的场景-->
      <div class="share_btn" v-else @click="toSharePoster(1)">分享集赞</div>
    </template>
    <!--文章状态：3 止步初选 4 进入复选-->
    <div
      class="share_btn"
      v-if="
        processStatus === 3 ||
          processStatus === 4 ||
          (processStatus === 2 && articleDetail.now_period_id != articleDetail.period_id)
      "
      @click="toSharePoster(1)"
    >
      分享
    </div>
    <share-poster
      ref="poster"
      :userName="articleDetail.name"
      :headImg="articleDetail.headicon"
      :type="posterType"
    ></share-poster>
  </div>
</template>
<script>
import Detail from '../components/detail.vue'
import Score from '../components/score'
import SharePoster from '@/summerCamp/components/sharePoster'
export default {
  name: 'ArticalDetail',
  components: {
    SharePoster,
    Detail,
    Score
  },
  data() {
    return {
      shareType: 2,
      userName: 'userName',
      url: '',
      isSelf: 1,
      message: {},
      articleDetail: {},
      posterType: 1,
      processStatus: 3 // 文章状态 0 AI待审核 1 审核不通过 2 初选中 3 止步初选 4 进入复选
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const that = this
      const { articleId } = this.$route.query
      console.log('articleId', typeof articleId)
      that.getArticleDetail(articleId)
    },
    // 获取文章详情
    async getArticleDetail(articleId) {
      const that = this
      const res = await that.$api.getArticleDetail({ artical_id: articleId.toString() })
      if (res.code === 0) {
        that.articleDetail = res.data
        that.processStatus = Number(that.articleDetail.process_status)
        that.isSelf = that.articleDetail.is_self ? 1 : 0
      } else {
        that.$toast(res.msg || '获取文章详情失败')
      }
    },
    /**
     * 分享海报
     * @param type 0：邀请好友助力 1：分享
     */
    toSharePoster(type) {
      this.$xesLogger.clickMsg({
        params: { clickid: '52.0.0', elemname: '分享海报', type }
      })
      this.posterType = type
      this.$refs.poster.show()
    }
  }
}
</script>
<style lang="less" scoped>
.article-detail {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-bottom: 23px;
  font-family: PingFangSC-Regular, PingFang SC;

  //.detail-content {
  //  //min-height: 200px;
  //  flex: 1;
  //  overflow: hidden;
  //}

  .otherDetail {
    padding-bottom: 20px;
  }

  .article_title {
    margin: 10px 20px 7px;
    font-size: 19px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }

  .article_status {
    height: 34px;
    font-size: 13px;
    font-weight: 400;
    line-height: 34px;
    text-align: center;
    background: #ededed;
  }

  .article_status_success {
    color: #000;
    background: linear-gradient(90deg, #ffd696 0%, #ffe6b6 100%);
  }

  .article_status_ing {
    color: #e02727;
    background: rgba(224, 39, 39, 0.1);
  }

  .article_message {
    display: flex;
    justify-content: space-between;
    margin: 0 20px;

    &_user {
      .headicon {
        width: 20px;
        height: 20px;
        border-radius: 20px;
      }

      .name {
        margin-left: 4px;
        font-size: 13px;
        vertical-align: -1px;
        color: #333;
      }

      .label {
        padding: 0 4px;
        margin-left: 4px;
        font-size: 11px;
        font-weight: 400;
        vertical-align: -1px;
        color: #333;
        background: rgba(51, 51, 51, 0.05);
        border-radius: 2px;
      }
    }
  }

  .comment {
    width: 335px;
    padding: 16px;
    margin: 20px 20px 0;
    background-image: url('../assets/apply/comment_bg.png');
    background-size: cover;
    background-repeat: no-repeat;

    .teacher_name {
      font-size: 17px;
      font-weight: 500;
      color: #603003;
    }

    .comment_content {
      font-size: 15px;
      font-weight: 400;
      color: #a0774e;
    }
  }

  .share_btn {
    width: 188px;
    height: 40px;
    margin: 20px auto 0;
    font-size: 15px;
    font-weight: 500;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #e02727;
    border-radius: 20px;
  }

  .share_tip {
    margin-top: 8px;
    font-size: 13px;
    text-align: center;
    color: #999;
  }

  .status {
    position: absolute;
    top: 128px;
    left: 0;
    z-index: 2;
    width: 100%;
    background: red;
  }
}
</style>
<style lang="less">
.van-swipe__indicators {
  bottom: 12px !important;
}

.detail {
  //min-height: 200px;
  flex: 1;
  overflow: hidden;
}
</style>
